import type { TAdminDashboardInfo } from 'app/pages/Admin/DashboardPage/types/TAdminDashboardInfo';

type TProps = {
  dashboard?: Partial<TAdminDashboardInfo>;
  onNotify: () => void;
};

export const SummaryCards = ({ dashboard, onNotify }: TProps) => (
  <div className="flex flex-wrap gap-2.5 justify-between items-start w-full">
    <div className="flex flex-wrap gap-2.5 justify-between items-start w-full">
      <div className="min-w-0 basis-[200px] min-h-[120px] bg-[var(--color-surface)] shadow-[0_8px_10px_var(--color-shadow)] rounded-[10px] p-5 relative flex-1">
        <div className="text-[var(--color-text-muted)] font-medium text-lg leading-[150%] whitespace-nowrap overflow-hidden text-ellipsis">
          Users online
        </div>
        <div className="text-[var(--color-accent)] font-semibold text-[30px] leading-[47px] -mt-0.5">
          {dashboard?.onlineUsers ?? 0} Total
        </div>
        <div className="text-[var(--color-text-muted)] text-xs leading-[120%]">
          <button type="button" onClick={onNotify} className="bg-transparent border-none cursor-pointer">
            Notify to update page
          </button>
        </div>
      </div>
      <div className="min-w-0 basis-[200px] min-h-[120px] bg-[var(--color-surface)] shadow-[0_8px_10px_var(--color-shadow)] rounded-[10px] p-5 relative flex-1">
        <div className="text-[var(--color-text-muted)] font-medium text-lg leading-[150%] whitespace-nowrap overflow-hidden text-ellipsis">
          Organizations
        </div>
        <div className="text-[var(--color-accent)] font-semibold text-[30px] leading-[47px] -mt-0.5">
          {dashboard?.organizationsCount ?? 0} Total
        </div>
      </div>
      <div className="min-w-0 basis-[200px] min-h-[120px] bg-[var(--color-surface)] shadow-[0_8px_10px_var(--color-shadow)] rounded-[10px] p-5 relative flex-1">
        <div className="text-[var(--color-text-muted)] font-medium text-lg leading-[150%] whitespace-nowrap overflow-hidden text-ellipsis">
          Workspaces
        </div>
        <div className="text-[var(--color-accent)] font-semibold text-[30px] leading-[47px] -mt-0.5">
          {dashboard?.workspacesCount ?? 0} Total
        </div>
      </div>
      <div className="min-w-0 basis-[200px] min-h-[120px] bg-[var(--color-surface)] shadow-[0_8px_10px_var(--color-shadow)] rounded-[10px] p-5 relative flex-1">
        <div className="text-[var(--color-text-muted)] font-medium text-lg leading-[150%] whitespace-nowrap overflow-hidden text-ellipsis">
          Users
        </div>
        <div className="text-[var(--color-accent)] font-semibold text-[30px] leading-[47px] -mt-0.5">
          {dashboard?.usersCount ?? 0} Total
        </div>
      </div>
      <div className="min-w-0 basis-[200px] min-h-[120px] bg-[var(--color-surface)] shadow-[0_8px_10px_var(--color-shadow)] rounded-[10px] p-5 relative flex-1">
        <div className="text-[var(--color-text-muted)] font-medium text-lg leading-[150%] whitespace-nowrap overflow-hidden text-ellipsis">
          Transactions
        </div>
        <div className="text-[var(--color-accent)] font-semibold text-[30px] leading-[47px] -mt-0.5">
          {dashboard?.transactionsCount ?? 0} Total
        </div>
      </div>
    </div>
  </div>
);
